import * as ActionType from '../../constants/actionType';
import {ModalSize} from '../../constants/dataEnum';

const initialState = {
  header: '',
  content: '',
  show: false,
  btnAction: [],
  isValid: true,
  onClose: null,
  className: '',
  closeDisabled: false,
  timerInterval: null,
  errorCodeNumber: 0, // used to display the error number on modal component
  actualErrorCodeNumber: 0, // used to check error number in real time without waiting for timeout on hideLaoding to clear out the error number
  previousErrorModalState: {
    header: '',
    content: '',
    errorCodeNumber: 0,
  },
  modalSize: ModalSize.LARGE,
  style: null,
  type: '',
  confirmationCheckbox: undefined,
};

export default function modalStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_APP_MODAL: {
      const newState = {...state, ...action.modalState};
      return {...state, ...newState};
    }
    case ActionType.SET_MODAL_VALID:
      return {...state, isValid: true};
    case ActionType.SET_MODAL_INVALID:
      return {...state, isValid: false};
    case ActionType.SET_MODAL_CONTENT:
      return {...state, content: action.content};
    case ActionType.SET_TIMER_INTERVAL:
      return {...state, timerInterval: action.timerInterval};
    case ActionType.SET_MODAL_ERROR_CODE_NUMBER:
      return {
        ...state,
        errorCodeNumber: action.errorCodeNumber,
        actualErrorCodeNumber: action.errorCodeNumber,
      };
    case ActionType.CLEAR_MODAL_ERROR:
      return {...state, errorCodeNumber: 0};
    case ActionType.CLEAR_TIMER_INTERVAL:
      return {...state, timerInterval: null};
    case ActionType.SET_MODAL_TYPE:
      return {...state, type: action.modalType};
    case ActionType.RESTORE_MODALSTATE:
      return action.state;
    case ActionType.RESET_MODALSTATE:
      return initialState;
    case ActionType.CLEAR_PREVIOUS_ERROR_MODAL:
      return {...state, previousErrorModalState: initialState.previousErrorModalState};
    default:
      return state;
  }
}
